import styled from 'styled-components';

import { gray1, gray2, gray5 } from './Const';

export const PreziCardOuterDiv = styled.div`
    margin-bottom: 15px;
    border-radius: 3px;
    background-color: white;
    overflow: auto;
    transition: 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 6px 18px 0 fade(${gray1}, 30%);
    }

    @media (min-width: 768px) {
        margin-bottom: 30px;
    }
`;

export const ReuseContainerStyles = styled.div`
    width: 42px;
    height: 42px;
    position: absolute;
    right: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #18bb54;
    border: 1px solid #61ea65;
    border-top: 0px;
    border-radius: 0px 0px 6px 6px;
`;

export const ReuseIcon = styled.i`
    color: white;
    font-size: 30px;
`;

export const TextTruncate = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ThumbnailInfo = styled.div`
    padding: 18px 18px 24px 18px;
    color: ${gray2};
    height: 160px;

    @media (min-width: 992px) {
        height: 126px;
    }
`;

export const PreziImage = styled.img`
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const PreziThumbnail = styled.div`
    background-color: ${gray5};

    @media (min-width: 768px) {
        height: 124px;
    }

    @media (min-width: 992px) {
        height: 165px;
    }

    @media (min-width: 1200px) {
        height: 166px;
    }
`;



// WEBPACK FOOTER //
// ./assets/js/styles/PreziCard.ts